<template>
  <div id="footer">
    <div class="cont container">
      <div class="logo">
        <img src="@/assets/img/logo.png" alt="logo图">
      </div>
      <div class="cont_xx">
        <div class="cont_xx_left">
          <!-- <div>
            <div class="cont_xx_left_title">加入我们</div>
            <div class="cont_xx_left_text">校园招聘</div>
            <div class="cont_xx_left_text">社会招聘</div>
            <div class="cont_xx_left_text">实习生招聘</div>
          </div> -->
          <div>
            <div class="cont_xx_left_title">联系我们</div>
            <div class="cont_xx_left_text">客户服务</div>
            <div class="cont_xx_left_text">合作洽谈</div>
          </div>
          <div>
            <div class="cont_xx_left_title">法律信息</div>
            <div class="cont_xx_left_text">服务协议</div>
            <div class="cont_xx_left_text">隐私政策</div>
            <div class="cont_xx_left_text">知识产权</div>
          </div>
          <div>
            <div class="cont_xx_left_title">法律声明</div>
            <div class="cont_xx_left_text">辽ICP备2025054476号-1</div>
            <!-- <div class="cont_xx_left_text">京B2-20170846</div> -->
          </div>
          <div>
            <div class="cont_xx_left_title">公司地址</div>
            <div class="cont_xx_left_text">
              <img src="https://1234asdgqwe.oss-cn-beijing.aliyuncs.com/img/dizi.png" alt="" class="gsdz">
            </div>
          </div>
        </div>
        <div class="cont_xx_right">
          <div>
            <div class="cont_xx_left_title">
              <img src="https://1234asdgqwe.oss-cn-beijing.aliyuncs.com/img/weixin1@1x.png" alt="" class="gywm">
              <span>关注我们</span>
            </div>
            <div class="ewm">
              <img src="https://1234asdgqwe.oss-cn-beijing.aliyuncs.com/img/ewm.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 众创联晟 版权所有</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "Footer",
    data() {
      return {};
    }
  };
</script>
<style scoped lang="scss">
  #footer {
    width: 100vw;
    height: 100%;
    color: #fff;
    background: #192238;
    overflow: hidden;
    text-align: center;
  }



  .logo {
    width: 95px;
    margin: 30px 0 33px;
  }

  .logo img {
    width: 66.63px;
    height: 14px;
  }

  .cont_xx {
    display: flex;
    justify-content: space-between;
  }

  .cont_xx_left {
    width: 60%;
    border: 1rpx solid red;
    display: flex;
    justify-content: space-between;
  }

  .cont_xx_left,
  .cont_xx_right {


    .cont_xx_left_title {
      font-size: 14px;
      color: #fff;
      font-weight: 600;
      margin-bottom: 15px;


      display: flex;
      align-items: center;
      justify-content: start;

      .gywm {
        width: 16px;
        height: 13px;
        margin-right: 5px;
      }
    }

    .cont_xx_left_text {
      font-size: 12px;
      color: #fff;
      font-weight: 300;
      margin-bottom: 10px;

      .gsdz {
        width: 160px;
        height: 80px;
      }
    }

    .ewm {
      width: 80px;
      height: 80px;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 70px;
        height: 70px;
      }
    }
  }

  .cont_xx_left>div,
  .cont_xx_right>div {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
  }

  .copy {
    margin-top: 133px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 10px 0;
    text-align: left;
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
  }

  @media screen and (max-width: 997px) {
    #footer {
      padding: 0 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue